import { render } from "./Comments.vue?vue&type=template&id=af7b71dc&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=af7b71dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af7b71dc"

export default script